module.exports = __webpack_public_path__ + "static/media/favourite-full.dfcccfc2.svg";